export default {
  panel: {
    panelTooltip: {
      notes: 'Tooltip for a panel',
      message: '{{cellId}}: Screen panel',
    },
  },
};
